import useGetSubCategories from './useGetSubCategories'

export default useGetSubCategories
